module.exports = __webpack_public_path__ + "img/stor_wrapbg6.67e8eef7.png";